<template>
  <section class="d-flex" style="gap: 8px;">
    <div v-for="(badge, index) in badges" :key="index">
      <v-tooltip :left="isAppleStoreShowLeft(badge.icon)" :right="!isAppleStoreShowLeft(badge.icon)">
        <template v-slot:activator="{ on }">
          <button @click="openLink(badge.link)" v-on="on">
            <component :is="badge.icon" />
          </button>
        </template>
        <span>{{ $vuetify.lang.t(`${badge.tooltip}`) }}</span>
      </v-tooltip>
    </div>
  </section>
</template>

<script>
import AppleStoreBadge from '@/components/login/badges/AppStoreBadge.vue';
import GooglePlayBadge from '@/components/login/badges/GooglePlayBadge.vue';

export default {
  components: {
    AppleStoreBadge,
    GooglePlayBadge,
  },
  name: 'MobileStore',
  data() {
    return {
      badges: [
        { icon: 'AppleStoreBadge', tooltip: '$vuetify.redirecionar', link: 'https://apps.apple.com/br/app/trinity-supply-chain/id6504614867' },
        { icon: 'GooglePlayBadge', tooltip: '$vuetify.redirecionar', link: 'https://play.google.com/store/apps/details?id=com.trinityApp&pcampaignid=web_share' },
      ],
    };
  },
  methods: {
    openLink(link) {
      window.open(link);
    },
    isAppleStoreShowLeft(icon) {
      return icon === 'AppleStoreBadge';
    },
  },
};
</script>
